import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { registry as getRegistry } from '@cian/mf-registry/browser';
import { getTelemetry } from '@cian/telemetry/browser';
import { IApplicationState } from '../../../shared/types/redux';
import { TThunkDispatch } from '../../../shared/types/redux/thunk';
import { createReduxStore } from '../../../shared/utils/redux';
import { getFlatTourBookingSchedule } from '../flatTourBooking';
import { createMicrofrontendsAPI } from '../microfrontends/createMicrofrontendsAPI';

export function createApplicationState() {
  const config = getConfig();
  const httpApi = getHttpApi();
  const logger = getLogger();
  const microfrontendsRegistry = getRegistry();
  const microfrontendsAPI = createMicrofrontendsAPI();
  const telemetry = getTelemetry();

  const initialState = config.getStrict<IApplicationState>('initialState');

  const reduxContext = {
    config,
    httpApi,
    logger,
    microfrontendsRegistry,
    microfrontendsAPI,
    telemetry,
  };

  const store = createReduxStore(initialState, reduxContext, true);
  (store.dispatch as TThunkDispatch)(getFlatTourBookingSchedule());

  return store;
}
